import React, { useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import MuiTableContainer from '../DrilldownMuiTable/MuiTableContainer';
import { defaultSalesTableHeader } from './TableHeader';
import { useDispatch, useSelector } from 'react-redux';
import { UserPortalContext } from '../../../context/appcontext';
import {
	getItemLocationGridStateData,
	getItemLocationGridStoreData,
} from '../../../redux/actions/itemDrillDownActions';
import { getKPIName } from '../../../helper/commonUtils';
import { ThemeProvider } from '@material-ui/core/styles';
import { Box } from '@mui/material';
import { theme } from '../../../theme/theme';
import analytics from '../../../helper/analytics';
import tracker from '../../../constants/tracker';
const Item = styled(Grid)(({ theme }) => ({
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

const LocationHeaderStore = defaultSalesTableHeader(
	'Sales_Item_Location_Store'
);
const LocationHeaderState = defaultSalesTableHeader(
	'Sales_Item_Location_State'
);

function Location(props) {
	const {
		category,
		weekFilter,
		selectedTab,
		selectedFilter,
		startDate,
		endDate,
		itemNum,
	} = props;
	const [value, setValue] = useState('State');
	const dropdownOptions = ['Store', 'State'];

	const isStore = value === 'Store';

	const dispatch = useDispatch();
	const portalUserContext = useContext(UserPortalContext);

	const itemLocationGridStateData = useSelector(
		(state) => state.itemDrillDownReducer.itemLocationGridStateData
	);
	const isLoadingLocationStateData = useSelector(
		(state) => state.itemDrillDownReducer.isLoadingItemLocationGridStateData
	);
	const errorLocationStateData = useSelector(
		(state) => state.itemDrillDownReducer.isItemLocationGridStateError
	);
	const itemLocationGridStoreData = useSelector(
		(state) => state.itemDrillDownReducer.itemLocationGridStoreData
	);
	const isLoadingLocationStoreData = useSelector(
		(state) => state.itemDrillDownReducer.isLoadingItemLocationGridStoreData
	);
	const errorLocationStoreData = useSelector(
		(state) => state.itemDrillDownReducer.isItemLocationGridStoreError
	);

	const kpiName = useSelector((state) => state.salesReducer.kpiName);
	const kpiType = getKPIName(kpiName);

	const salesSortBy = useSelector(
		(state) => state.itemDrillDownReducer.salesSortBy
	);

	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	useEffect(() => {
		const params = {
			categoryId: '-1',
			timePeriod: weekFilter,
			portalUserContext: portalUserContext,
			itemNum: itemNum,
			kpiType: kpiType,
			startDate,
			endDate,
		};
		dispatch(getItemLocationGridStateData(params));
		dispatch(getItemLocationGridStoreData(params));
	}, [weekFilter, category, itemNum, startDate, endDate, selectedView]);

	const getData = (item) => {
		return salesSortBy === 'desc' ? item?.bottomList : item?.topList;
	};

	useEffect(() => {
		const pageid = `${kpiName}Item${selectedTab}`
			.replaceAll(/\s/g, '')
			.toUpperCase();
		analytics.trackPageInfo(tracker.PAGE_ID[pageid]);
	});

	return (
		<ThemeProvider theme={theme}>
			<Box data-test-id="location-table" sx={{ flexGrow: 1 }}>
				<Grid container>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<Item>
							<MuiTableContainer
								tableHeaders={
									isStore ? LocationHeaderStore : LocationHeaderState
								}
								tableRows={
									isStore
										? getData(itemLocationGridStoreData?.locationGridData)
										: getData(itemLocationGridStateData?.locationGridData)
								}
								title={`${value} Metric`}
								category={category}
								weekFilter={weekFilter}
								selectedTab={selectedTab}
								selectedFilter={selectedFilter}
								options={dropdownOptions}
								selectedOption_={value}
								isLoading={
									isStore
										? isLoadingLocationStoreData
										: isLoadingLocationStateData
								}
								dataError={
									isStore ? errorLocationStoreData : errorLocationStateData
								}
								handleRowClick={() => {}}
								setValue={setValue}
								numberOfRecords={
									isStore
										? itemLocationGridStoreData?.numberOfRecords
										: itemLocationGridStateData?.numberOfRecords
								}
								isStore={isStore}
							/>
						</Item>
					</Grid>
				</Grid>
			</Box>
		</ThemeProvider>
	);
}

Location.propTypes = {
	category: PropTypes.string,
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	selectedTab: PropTypes.string,
	selectedFilter: PropTypes.string,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	itemNum: PropTypes.string,
};

export default Location;
